import { put, call } from "redux-saga/effects";

import { SAVE_FORGOTPASSWORD_COMPLETED,SAVE_FORGOTPASSWORD_FAILED,
    SAVE_FORGOTUSERNAME_COMPLETED,SAVE_FORGOTUSERNAME_FAILED
} from "../actions/Forgotpassword";

import { forgotpasswordApi } from "../../utils/api/ForgotpasswordApi";



export function* saveForgotpassword(request: any) {
 
    
    try {
       
         const result=yield call(forgotpasswordApi.saveforgotpassword, request.input);
     
        yield put({
            
            type: SAVE_FORGOTPASSWORD_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_FORGOTPASSWORD_FAILED, payload: e.message });
    }
}

export function* saveForgotUsername(request: any) {
 
    
    try {
       
         const result=yield call(forgotpasswordApi.saveforgotusername, request.input);
     
        yield put({
            
            type: SAVE_FORGOTUSERNAME_COMPLETED,     
            payload: result.data,
            input: request.input
        });
    } catch (e) {
        yield put({ type: SAVE_FORGOTUSERNAME_FAILED, payload: e.message });
    }
}